export default __webpack_public_path__ + "images/sleepwagen-garageca9d61eda16c56f70ef5fed77b9a2651.svg";